export const FETCH_REQUEST_EVENT = 'fetch:onrequest';
/**
 *
 * Allows you to listen to fetch requests (`fetch:onrequest` event) and modify them before they are sent.
 *
 * @example
 * ```ts
 * import { onFetchRequest } from '@catawiki/runtime-toolkit';
 *
 * onFetchRequest((request) => {
 * const token = getCookie(COOKIE.OAUTH_TOKEN);
 *
 *  if (token) {
 *    request.headers.append('Authorization', `Bearer ${token}`);
 *  }
 * })
 *
 * @param request
 */
export const onFetchRequest = (cb) => {
    addEventListener(FETCH_REQUEST_EVENT, (event) => {
        cb(event.detail);
    });
};
